import { useElementSize } from '@mantine/hooks';
import { useEffect, useRef } from 'react';

type Props = {
  logs: { key: string; message: string }[];
};

export default function Panel({ logs }: Props) {
  const { ref, height } = useElementSize();
  const scrollRef = useRef<HTMLDivElement>(null);

  // Scroll to bottom when new logs come in
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [logs]);

  return (
    <div
      ref={ref}
      className="h-full overflow-hidden border-t font-mono dark:border-neutral-700"
    >
      <div
        ref={scrollRef}
        className="scrollbar-thin scrollbar-thumb-gray-400/50 hover:scrollbar-thumb-gray-400 dark:scrollbar-thumb-gray-600/50 dark:hover:scrollbar-thumb-gray-600 absolute h-full w-full overflow-auto px-4 py-2"
        style={{ height }}
      >
        {logs.length === 0 ?
          <div className="flex h-full items-center justify-center">
            <div className="text-center">
              <div className="text-sm text-gray-500 dark:text-gray-400">No console entries</div>
              <div className="mt-1 text-xs text-gray-400 dark:text-gray-500">
                Console logs will appear here when available
              </div>
            </div>
          </div>
        : logs.map(({ key, message }) => (
            <div
              key={key}
              className="whitespace-pre-wrap border-b border-gray-200 py-1 text-xs text-gray-600 last:border-b-0 dark:border-gray-700 dark:text-gray-400"
            >
              {message}
            </div>
          ))
        }
      </div>
    </div>
  );
}
